import React from "react";

import bgVideo from "../../src/assets/herosection/bgvideo.mp4";
import playStoreImg from "../../src/assets/herosection/playstore.avif";
import appStoreImg from "../../src/assets/herosection/appstore.avif";
import logo from "../assets/jagods1.png";

export default function AppDownloadHero() {
    return (
        <section className="relative h-screen w-full overflow-hidden">
            {/* Background Video */}
            <video
                autoPlay
                muted
                loop
                playsInline
                className="absolute inset-0 h-full w-full object-cover"
            >
                <source src={bgVideo} type="video/mp4" />
            </video>

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/45" />

            {/* Content */}
            <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
                {/* Logo */}
                <img
                    src={logo}
                    alt="Jagods"
                    className="w-[220px] md:w-[320px] object-cover"
                />

                {/* Heading */}
                <h2 className="max-w-4xl text-4xl font-bold leading-tight text-white md:text-7xl">
Order Food & Groceries. Discover Best Restaurants.   
                    {/* <br /> */}
              </h2>

                {/* Description */}
                <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/90 md:text-3xl">
                    Experience fast & easy online ordering
                    <br />
                    on the Jagods app
                </p>

                {/* Store Buttons */}
                <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
                    <a href="https://play.google.com/store/apps/details?id=com.jagods.customer">
                        <img
                            src={playStoreImg}
                            alt="Google Play"
                            className="h-[60px] w-auto transition duration-300 hover:scale-105"
                        />
                    </a>

                    <a href="https://apps.apple.com/in/app/jagods/id6749576808">
                        <img
                            src={appStoreImg}
                            alt="App Store"
                            className="h-[60px] w-auto transition duration-300 hover:scale-105"
                        />
                    </a>
                </div>

                {/* Scroll Down */}
                {/* <div className="absolute bottom-10 flex flex-col items-center text-white">
                    <p className="text-lg font-medium tracking-wide">Scroll down</p>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mt-2 h-6 w-6 animate-bounce"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 9l-7 7-7-7"
                        />
                    </svg>
                </div> */}
            </div>
        </section>
    );
}